<script>
    import {
        ButtonGroup,
        Modal,
        ModalHeader,
        ModalBody,
        ModalFooter,
        Button,
        Row,
        Col,
        Card,
        CardHeader,
        CardFooter,
        CardBody,
        CardTitle,
        CardSubtitle,
        CardText,
    } from "@sveltestrap/sveltestrap";
    import ResCard from "./components/resCard.svelte";
    import MatchsTablesAccordion from "./components/matchsTablesAccordion.svelte";
    import Statistiques from "./components/statistiques.svelte";
    import MatchsTables from "./components/matchsTables.svelte";
    import ModalGraph from "./components/modalGraph.svelte";
    import ModalGraphCurSeason from "./components/modalGraphCurSeason.svelte";
    import ModalGraphAllSeasons from "./components/modalGraphAllSeasons.svelte";
    import ModalCmpt from "./components/modalCmpt.svelte";
    import { csvGenerator } from "./csvGenerator";

    let openInfo = false;
    const toggleInfo = () => (openInfo = !openInfo);

    let openInfoTop = false;
    const toggleInfoTop = () => (openInfoTop = !openInfoTop);

    let lic_stack = [];
    let lic_stack_nof = 0;

    let showModal = false;

    let showAccordion = true;

    let showGraphModal = false;
    let showGraphAllSeasonModal = false;

    let analysis_src = [];
    let analysis = {};

    let matchs = [];
    let classifs = [];
    let classifPrevSeason = false;
    let canShowGraph = true;
    let seasons = [];
    let joueurs = {};
    let joueursSrc = [];
    let joueursSearch = [];
    let data = [];

    let matchsByMode = [];
    let matchsByModeAll = [];
    let bestSerieByMode = [];
    let matchsByRes = [];
    let matchsByType = [];
    let matchsLic = [];
    let matchsLicAll = [];
    let classifsLic = {};
    let modes = [];
    let modesAll = [];
    let modesClassif = [];
    let res = ["Gagnés", "Perdus", "Nuls"];
    let adversaires = [];
    let season = "";
    let licence = "";
    let nomJoueur = "";
    let joueur = "";
    let licN = 0;
    let licL = "";
    let lic = "";
    let msg = "";

    let seasonsBestPlayed = {};
    let seasonsBestWon = {};
    let seasonsBestPctWon = {};
    let seasonsBest = {};
    let globalstats = [];

    let searchDone = false;

    let tableMatchsHeaders = [
        "Catég.",
        "Niveau",
        "Rés",
        "Pts",
        "Rep",
        "Sér",
        "Moy",
        "Adversaire",
        "Pts",
        "Rep",
        "Sér",
        "Moy",
        "Date",
        "Format",
        "L/H",
    ];
    let tableMatchRows = [];
    let tableMatchRowsAll = [];

    let promise = getData();
    let dimens = "col-lg-12 col-xl-10 col-xxl-9 col-sm-12 col-md-12 col-12";

    function goBack() {
        // console.log("go back " + lic_stack_nof)
        if (lic_stack_nof > 0) {
            let l = lic_stack.pop();
            // console.log(l)
            lic_stack_nof--;
            licence = l;
            nomJoueur = joueurs[l];
            searchDone = false;
            document.body.scrollIntoView();
            searchLic();
        }
    }

    function joueurChosen(e) {
        // console.log('joueurChosen')
        // console.log(e.detail)

        licence = e.detail[0];

        searchLic();
    }

    function serie2m80(s, md, fmt) {
        let sg = s;
        switch (md) {
            case "Libre":
                switch (fmt) {
                    case "2m60":
                        sg = sg * 0.8;
                        break;
                    case "3m10":
                        sg = sg / 0.8;
                        break;
                }
                break;
            case "Cadre 71/2":
                switch (fmt) {
                    case "3m10":
                        sg = sg / 0.8;
                        break;
                    case "2m60":
                        sg = sg * 0.9;
                        break;
                }
                break;
            case "Cadre 47/2":
                switch (fmt) {
                    case "3m10":
                        sg = sg / 0.8;
                        break;
                    case "2m60":
                        sg = sg * 0.9;
                        break;
                }
                break;
            case "Cadre 42/2":
                switch (fmt) {
                    case "3m10":
                        sg = sg / 0.8;
                        break;
                    case "2m60":
                        sg = sg * 0.9;
                        break;
                }
                break;
            case "1 Bande":
                switch (fmt) {
                    case "3m10":
                        sg = sg / 0.89;
                        break;
                    case "2m60":
                        sg = sg * 0.8;
                        break;
                }
                break;
            case "3 Bandes":
                switch (fmt) {
                    case "3m10":
                        sg = sg / 0.86;
                        break;
                    case "2m60":
                        sg = sg * 0.91;
                        break;
                }
                break;
        }

        return sg;
    }

    function avg2m80(p, r, md, fmt) {
        let pg = p;
        switch (md) {
            case "Libre":
                switch (fmt) {
                    case "2m60":
                        pg = pg * 0.8;
                        break;
                    case "3m10":
                        pg = pg / 0.8;
                        break;
                }
                break;
            case "Cadre 71/2":
                switch (fmt) {
                    case "3m10":
                        pg = pg / 0.8;
                        break;
                    case "2m60":
                        pg = pg * 0.9;
                        break;
                }
                break;
            case "Cadre 47/2":
                switch (fmt) {
                    case "3m10":
                        pg = pg / 0.8;
                        break;
                    case "2m60":
                        pg = pg * 0.9;
                        break;
                }
                break;
            case "Cadre 42/2":
                switch (fmt) {
                    case "3m10":
                        pg = pg / 0.8;
                        break;
                    case "2m60":
                        pg = pg * 0.9;
                        break;
                }
                break;
            case "1 Bande":
                switch (fmt) {
                    case "3m10":
                        pg = pg / 0.89;
                        break;
                    case "2m60":
                        pg = pg * 0.8;
                        break;
                }
                break;
            case "3 Bandes":
                switch (fmt) {
                    case "3m10":
                        pg = pg / 0.86;
                        break;
                    case "2m60":
                        pg = pg * 0.91;
                        break;
                }
                break;
        }

        return r == 0 ? 0 : pg / r;
    }

    function serie3m10(s, md, fmt) {
        let sg = s;
        switch (md) {
            case "Libre":
                switch (fmt) {
                    case "2m60":
                        sg = sg * 0.64;
                        break;
                    case "2m80":
                        sg = sg * 0.8;
                        break;
                }
                break;
            case "Cadre 71/2":
                switch (fmt) {
                    case "2m80":
                        sg = sg * 0.8;
                        break;
                    case "2m60":
                        sg = sg * 0.72;
                        break;
                }
                break;
            case "Cadre 47/2":
                switch (fmt) {
                    case "2m80":
                        sg = sg * 0.8;
                        break;
                    case "2m60":
                        sg = sg * 0.72;
                        break;
                }
                break;
            case "Cadre 42/2":
                switch (fmt) {
                    case "2m80":
                        sg = sg * 0.8;
                        break;
                    case "2m60":
                        sg = sg * 0.72;
                        break;
                }
                break;
            case "1 Bande":
                switch (fmt) {
                    case "2m80":
                        sg = sg * 0.89;
                        break;
                    case "2m60":
                        sg = sg * 0.712;
                        break;
                }
                break;
            case "3 Bandes":
                switch (fmt) {
                    case "2m80":
                        sg = sg * 0.86;
                        break;
                    case "2m60":
                        sg = sg * 0.7826;
                        break;
                }
                break;
        }

        return sg;
    }

    function avg3m10(p, r, md, fmt) {
        let pg = p;
        switch (md) {
            case "Libre":
                switch (fmt) {
                    case "2m60":
                        pg = pg * 0.64;
                        break;
                    case "2m80":
                        pg = pg * 0.8;
                        break;
                }
                break;
            case "Cadre 71/2":
                switch (fmt) {
                    case "2m80":
                        pg = pg * 0.8;
                        break;
                    case "2m60":
                        pg = pg * 0.72;
                        break;
                }
                break;
            case "Cadre 47/2":
                switch (fmt) {
                    case "2m80":
                        pg = pg * 0.8;
                        break;
                    case "2m60":
                        pg = pg * 0.72;
                        break;
                }
                break;
            case "Cadre 42/2":
                switch (fmt) {
                    case "2m80":
                        pg = pg * 0.8;
                        break;
                    case "2m60":
                        pg = pg * 0.72;
                        break;
                }
                break;
            case "1 Bande":
                switch (fmt) {
                    case "2m80":
                        pg = pg * 0.89;
                        break;
                    case "2m60":
                        pg = pg * 0.712;
                        break;
                }
                break;
            case "3 Bandes":
                switch (fmt) {
                    case "2m80":
                        pg = pg * 0.86;
                        break;
                    case "2m60":
                        pg = pg * 0.7826;
                        break;
                }
                break;
        }

        return r == 0 ? 0 : pg / r;
    }

    function prepareTableMatch() {
        // console.log(Object.keys(matchsByMode))
        tableMatchRows = [];
        // modesClassif.forEach((md) =>  {
        Object.keys(matchsByMode).forEach((md) => {
            if (matchsByMode[md] != undefined) {
                if (!tableMatchRows[md]) {
                    tableMatchRows[md] = [];
                }
                matchsByMode[md].forEach((m, i) => {
                    let theM = [];
                    let moyJ;
                    let moyJ280;
                    let moyJ310;
                    let moyA;
                    let moyA280;
                    let moyA310;
                    let sr280;
                    let sr310;
                    let p;
                    let r;
                    let s;
                    let pa;
                    let ra;
                    theM.push(m[2]);

                    // if (m[16]=='E')
                    // 	theM.push('Eq.')
                    // else
                    // 	theM.push('Ind.')

                    if (m[15] == "I") theM.push("Intl.");
                    else if (m[15] == "N") theM.push("Nat.");
                    else if (m[15] == "L") theM.push("Ligue");
                    else if (m[15] == "D") theM.push("CDB");
                    else theM.push("---");

                    if (m[4] == lic) {
                        if (parseInt(m[8]) == 2) theM.push("G");
                        else if (m[8] == 0) theM.push("P");
                        else theM.push("N");

                        p = parseInt(m[5]);
                        r = parseInt(m[6]);
                        s = parseInt(m[7]);
                        theM.push(p);
                        theM.push(r);
                        theM.push(s);
                        moyJ = r == 0 ? 0 : p / r;
                        moyJ280 = avg2m80(p, r, md, m[14]);
                        moyJ310 = avg3m10(p, r, md, m[14]);
                        sr280 = serie2m80(s, md, m[14]);
                        sr310 = serie3m10(s, md, m[14]);

                        theM.push((md == "3 Bandes" ? moyJ.toFixed(3) : moyJ.toFixed(2)).replace(".", ","));

                        theM.push(m[9]);

                        pa = parseInt(m[10]);
                        ra = parseInt(m[11]);
                        theM.push(pa);
                        theM.push(ra);
                        theM.push(parseInt(m[12]));
                        moyA = ra == 0 ? 0 : pa / ra;
                        // moyA280=avg2m80(pa,ra,md, m[14])
                        // moyA310=avg3m10(pa,ra,md, m[14])
                        theM.push((md == "3 Bandes" ? moyA.toFixed(3) : moyA.toFixed(2)).replace(".", ","));
                    } else if (m[9] == lic) {
                        if (parseInt(m[8]) == 2) theM.push("P");
                        else if (m[8] == 0) theM.push("G");
                        else theM.push("N");

                        p = parseInt(m[10]);
                        r = parseInt(m[11]);
                        s = parseInt(m[12]);
                        theM.push(p);
                        theM.push(r);
                        theM.push(s);
                        moyJ = r == 0 ? 0 : p / r;
                        moyJ280 = avg2m80(p, r, md, m[14]);
                        moyJ310 = avg3m10(p, r, md, m[14]);
                        sr280 = serie2m80(s, md, m[14]);
                        sr310 = serie3m10(s, md, m[14]);
                        theM.push((md == "3 Bandes" ? moyJ.toFixed(3) : moyJ.toFixed(2)).replace(".", ","));

                        theM.push(m[4]);

                        pa = parseInt(m[5]);
                        ra = parseInt(m[6]);
                        theM.push(pa);
                        theM.push(ra);
                        theM.push(parseInt(m[7]));
                        moyA = ra == 0 ? 0 : pa / ra;
                        // moyA280=avg2m80(pa,ra,md, m[14])
                        // moyA310=avg3m10(pa,ra,md, m[14])
                        theM.push((md == "3 Bandes" ? moyA.toFixed(3) : moyA.toFixed(2)).replace(".", ","));
                    }
                    theM.push(m[1]);
                    theM.push(m[14]);
                    theM.push(m[17]);
                    theM.push(i + 1);
                    theM.push(moyJ280);
                    theM.push(moyJ310);
                    theM.push(sr280);
                    theM.push(sr310);
                    tableMatchRows[md].push(theM);
                });
            }
        });

        //Saison	Date	Catégorie	Mode de jeu	Licence 1	Pts 1	Reprises 1	Meilleure Série 1	Pts Match 1	Licence 2	Pts 2	Reprises 2
        // 0		1		2			3			4			5		6			7					8			9			10		11
        //Meilleure Série 2	Pts Match 2	Format	Niveau	Type	L_H
        //12				13			14		15		16		17
        // console.log('preparetablematchrows')
        // console.log(tableMatchRows)
    }

    function prepareTableMatchAll() {
        // console.log(Object.keys(matchsByMode))
        tableMatchRowsAll = [];
        // modesClassif.forEach((md) =>  {
        Object.keys(matchsByModeAll).forEach((md) => {
            if (matchsByModeAll[md] != undefined) {
                if (!tableMatchRowsAll[md]) {
                    tableMatchRowsAll[md] = [];
                }
                matchsByModeAll[md].forEach((m, i) => {
                    let theM = [];
                    let moyJ;
                    let moyJ280;
                    let moyJ310;
                    let moyfdjJ280;
                    let moyfdjJ310;
                    let moyA;
                    let moyA280;
                    let moyA310;
                    let sr280;
                    let sr310;
                    let p;
                    let r;
                    let s;
                    let pa;
                    let ra;
                    theM.push(m[2]);

                    // if (m[16]=='E')
                    // 	theM.push('Eq.')
                    // else
                    // 	theM.push('Ind.')

                    if (m[15] == "I") theM.push("Intl.");
                    else if (m[15] == "N") theM.push("Nat.");
                    else if (m[15] == "L") theM.push("Ligue");
                    else if (m[15] == "D") theM.push("CDB");
                    else theM.push("---");

                    if (m[4] == lic) {
                        if (parseInt(m[8]) == 2) theM.push("G");
                        else if (m[8] == 0) theM.push("P");
                        else theM.push("N");

                        p = parseInt(m[5]);
                        r = parseInt(m[6]);
                        s = parseInt(m[7]);
                        theM.push(p);
                        theM.push(r);
                        theM.push(s);
                        moyJ = r == 0 ? 0 : p / r;
                        moyJ280 = avg2m80(p, r, md, m[14]);
                        moyJ310 = avg3m10(p, r, md, m[14]);
                        sr280 = serie2m80(s, md, m[14]);
                        sr310 = serie3m10(s, md, m[14]);
                        moyfdjJ280 = avg2m80(p - s, r - 1, md, m[14]);
                        moyfdjJ310 = avg3m10(p - s, r - 1, md, m[14]);

                        theM.push((md == "3 Bandes" ? moyJ.toFixed(3) : moyJ.toFixed(2)).replace(".", ","));

                        theM.push(m[9]);

                        pa = parseInt(m[10]);
                        ra = parseInt(m[11]);
                        theM.push(pa);
                        theM.push(ra);
                        theM.push(parseInt(m[12]));
                        moyA = ra == 0 ? 0 : pa / ra;
                        // moyA280=avg2m80(pa,ra,md, m[14])
                        // moyA310=avg3m10(pa,ra,md, m[14])
                        theM.push((md == "3 Bandes" ? moyA.toFixed(3) : moyA.toFixed(2)).replace(".", ","));
                    } else if (m[9] == lic) {
                        if (parseInt(m[8]) == 2) theM.push("P");
                        else if (m[8] == 0) theM.push("G");
                        else theM.push("N");

                        p = parseInt(m[10]);
                        r = parseInt(m[11]);
                        s = parseInt(m[12]);
                        theM.push(p);
                        theM.push(r);
                        theM.push(s);
                        moyJ = r == 0 ? 0 : p / r;
                        moyJ280 = avg2m80(p, r, md, m[14]);
                        moyJ310 = avg3m10(p, r, md, m[14]);
                        sr280 = serie2m80(s, md, m[14]);
                        sr310 = serie3m10(s, md, m[14]);
                        moyfdjJ280 = avg2m80(p - s, r - 1, md, m[14]);
                        moyfdjJ310 = avg3m10(p - s, r - 1, md, m[14]);
                        theM.push((md == "3 Bandes" ? moyJ.toFixed(3) : moyJ.toFixed(2)).replace(".", ","));

                        theM.push(m[4]);

                        pa = parseInt(m[5]);
                        ra = parseInt(m[6]);
                        theM.push(pa);
                        theM.push(ra);
                        theM.push(parseInt(m[7]));
                        moyA = ra == 0 ? 0 : pa / ra;
                        // moyA280=avg2m80(pa,ra,md, m[14])
                        // moyA310=avg3m10(pa,ra,md, m[14])
                        theM.push((md == "3 Bandes" ? moyA.toFixed(3) : moyA.toFixed(2)).replace(".", ","));
                    }
                    theM.push(m[1]);
                    theM.push(m[14]);
                    theM.push(m[17]);
                    theM.push(i + 1);
                    theM.push(moyJ280);
                    theM.push(moyJ310);
                    theM.push(sr280);
                    theM.push(sr310);
                    theM.push(moyfdjJ280);
                    theM.push(moyfdjJ310);
                    tableMatchRowsAll[md].push(theM);
                });
            }
        });

        //Saison	Date	Catégorie	Mode de jeu	Licence 1	Pts 1	Reprises 1	Meilleure Série 1	Pts Match 1	Licence 2	Pts 2	Reprises 2
        // 0		1		2			3			4			5		6			7					8			9			10		11
        //Meilleure Série 2	Pts Match 2	Format	Niveau	Type	L_H
        //12				13			14		15		16		17

        // console.log(tableMatchRows)
    }

    function exportCSV() {
        let tableHeader = [
            "Saison",
            "Date",
            "Mode de jeu",
            "Categorie",
            "Type",
            "Niveau",
            "Format",
            "Loisir/Handicap",
            "Pts",
            "Rep",
            "MS",
            "Moy",
            "Moy 2m80",
            "Moy 3m10",
            "PM",
            "Adversaire",
            "Pts Adv",
            "Rep Adv",
            "MS Adv",
            "Moy Adv",
            "Moy Adv 2m80",
            "Moy Adv 3m10",
        ];
        let tableData = [];

        let matchsToExport = [];

        matchs.forEach((m) => {
            if (m[4] == lic || m[9] == lic) matchsToExport.push(m);
        });

        //Saison	Date	Catégorie	Mode de jeu	Licence 1	Pts 1	Reprises 1	Meilleure Série 1	Pts Match 1	Licence 2	Pts 2	Reprises 2
        // 0		1		2			3			4			5		6			7					8			9			10		11
        //Meilleure Série 2	Pts Match 2	Format	Niveau	Type	L_H
        //12				13			14		15		16		17
        matchsToExport.forEach((m) => {
            let moyJ;
            let moyJ280;
            let moyJ310;
            let moyA;
            let moyA280;
            let moyA310;
            let p;
            let r;
            let pa;
            let ra;
            let obj = {};

            obj["Saison"] = m[0];
            obj["Date"] = m[1];
            obj["Mode de jeu"] = m[3];
            obj["Categorie"] = m[2];
            obj["Type"] = m[16] == "I" ? "Individuelle" : "Equipe";

            switch (m[15]) {
                case "I":
                    obj["Niveau"] = "International";
                    break;
                case "N":
                    obj["Niveau"] = "National";
                    break;
                case "L":
                    obj["Niveau"] = "Ligue";
                    break;
                case "D":
                    obj["Niveau"] = "CDB";
                    break;
            }
            obj["Format"] = m[14];
            obj["Loisir/Handicap"] = m[17];
            if (m[4] == lic) {
                p = parseInt(m[5]);
                r = parseInt(m[6]);
                moyJ = r == 0 ? 0 : p / r;
                moyJ280 = avg2m80(p, r, m[3], m[14]);
                moyJ310 = avg3m10(p, r, m[3], m[14]);
                obj["Pts"] = p;
                obj["Rep"] = r;
                obj["MS"] = m[7];
                obj["Moy"] = m[3] == "3 Bandes" ? moyJ.toFixed(3).replace(".", ",") : moyJ.toFixed(2).replace(".", ",");
                obj["Moy 2m80"] = m[3] == "3 Bandes" ? moyJ280.toFixed(3).replace(".", ",") : moyJ280.toFixed(2).replace(".", ",");
                obj["Moy 3m10"] = m[3] == "3 Bandes" ? moyJ310.toFixed(3).replace(".", ",") : moyJ310.toFixed(2).replace(".", ",");

                obj["PM"] = m[8];

                obj["Adversaire"] = joueurs[m[9]];
                pa = parseInt(m[10]);
                ra = parseInt(m[11]);
                moyA = ra == 0 ? 0 : pa / ra;
                moyA280 = avg2m80(pa, ra, m[3], m[14]);
                moyA310 = avg3m10(pa, ra, m[3], m[14]);
                obj["Pts Adv"] = pa;
                obj["Rep Adv"] = ra;
                obj["MS Adv"] = m[12];
                obj["Moy Adv"] = m[3] == "3 Bandes" ? moyA.toFixed(3).replace(".", ",") : moyA.toFixed(2).replace(".", ",");
                obj["Moy Adv 2m80"] = m[3] == "3 Bandes" ? moyA280.toFixed(3).replace(".", ",") : moyA280.toFixed(2).replace(".", ",");
                obj["Moy Adv 3m10"] = m[3] == "3 Bandes" ? moyA310.toFixed(3).replace(".", ",") : moyA310.toFixed(2).replace(".", ",");
            } else {
                p = parseInt(m[10]);
                r = parseInt(m[11]);
                moyJ = r == 0 ? 0 : p / r;
                moyJ280 = avg2m80(p, r, m[3], m[14]);
                moyJ310 = avg3m10(p, r, m[3], m[14]);
                obj["Pts"] = p;
                obj["Rep"] = r;
                obj["MS"] = m[12];
                obj["Moy"] = m[3] == "3 Bandes" ? moyJ.toFixed(3).replace(".", ",") : moyJ.toFixed(2).replace(".", ",");
                obj["Moy 2m80"] = m[3] == "3 Bandes" ? moyJ280.toFixed(3).replace(".", ",") : moyJ280.toFixed(2).replace(".", ",");
                obj["Moy 3m10"] = m[3] == "3 Bandes" ? moyJ310.toFixed(3).replace(".", ",") : moyJ310.toFixed(2).replace(".", ",");
                obj["PM"] = m[13];
                obj["Adversaire"] = joueurs[m[4]];
                pa = parseInt(m[5]);
                ra = parseInt(m[6]);
                moyA = ra == 0 ? 0 : pa / ra;
                moyA280 = avg2m80(pa, ra, m[3], m[14]);
                moyA310 = avg3m10(pa, ra, m[3], m[14]);
                obj["Pts Adv"] = pa;
                obj["Rep Adv"] = ra;
                obj["MS Adv"] = m[12];
                obj["Moy Adv"] = m[3] == "3 Bandes" ? moyA.toFixed(3).replace(".", ",") : moyA.toFixed(2).replace(".", ",");
                obj["Moy Adv 2m80"] = m[3] == "3 Bandes" ? moyA280.toFixed(3).replace(".", ",") : moyA280.toFixed(2).replace(".", ",");
                obj["Moy Adv 3m10"] = m[3] == "3 Bandes" ? moyA310.toFixed(3).replace(".", ",") : moyA310.toFixed(2).replace(".", ",");
            }

            tableData.push(obj);
        });
        let tableKeys = Object.keys(tableData[0]);
        csvGenerator(tableData, tableKeys, tableHeader, "matchs " + joueurs[lic] + ".csv");
    }

    function clickTop(event) {
        // console.log(event.detail)
        licence = event.detail.l;
        nomJoueur = joueurs[event.detail.l];
        document.body.scrollIntoView();
        searchLic();
    }

    function clickAdv(event) {
        // console.log(event.detail)
        changeLic(event.detail.l);
    }

    function changeLic(lic) {
        lic_stack.push(licence);
        lic_stack_nof++;
        licence = lic;
        nomJoueur = joueurs[lic];
        document.body.scrollIntoView();
        searchLic();
    }

    async function getData() {
        // console.log('getdata')
        const res = await fetch("https://apps.ffbillard.com/carambole_matchs/PHP/getdataandsummary.php");

        // const res = await fetch("https://apps.ffbillard.com/cm_test/PHP/getdataandsummary.php");

        const json = await res.json();
        // console.log('getdata end')
        // console.log(json)
        joueursSrc = json["joueurs"];
        json["joueurs"].forEach((j) => {
            joueurs[j[0]] = j[1];
        });
        matchs = json["matchs"];
        seasons = [];
        json["saisons"].forEach((s) => {
            seasons.push(s[0]);
        });
        classifs = json["classifs"];
        globalstats = json["globalstats"];

        season = seasons[seasons.length - 1];
        // console.log('getdata')
        // console.log(season)
        // console.log(seasons)

        analysis_src = json["matchs_analysis"];
        build_data_analysis();
        build_seasons_best();
        // TOPperformers(2024,10,50)
        return json;
    }

    function build_seasons_best() {
        // seasons.forEach((s) => {seasonsBest[s]})

        // console.log(seasonsBest)
        matchs.forEach((m) => {
            let s = m[0];
            let j1 = m[4];
            let j2 = m[9];
            let pm = m[8];

            if (!seasonsBestPlayed[s]) seasonsBestPlayed[s] = {};
            if (!seasonsBestPlayed[s][j1]) seasonsBestPlayed[s][j1] = 0;
            if (!seasonsBestPlayed[s][j2]) seasonsBestPlayed[s][j2] = 0;
            seasonsBestPlayed[s][j1]++;
            seasonsBestPlayed[s][j2]++;

            if (!seasonsBestWon[s]) seasonsBestWon[s] = {};
            if (pm == 2) {
                if (!seasonsBestWon[s][j1]) seasonsBestWon[s][j1] = 0;
                seasonsBestWon[s][j1]++;
            }
            if (pm == 0) {
                if (!seasonsBestWon[s][j2]) seasonsBestWon[s][j2] = 0;
                seasonsBestWon[s][j2]++;
            }

            if (!seasonsBestPctWon[s]) seasonsBestPctWon[s] = {};
            if (!seasonsBestPctWon[s][j1]) seasonsBestPctWon[s][j1] = 0;
            if (!seasonsBestPctWon[s][j2]) seasonsBestPctWon[s][j2] = 0;
            // if (seasonsBest[s][j1]==undefined)
            // 	(seasonsBest[s]).push( {j : j1, played:0, won:0, pctwon:0})
            // if (seasonsBest[s][j2]==undefined)
            // 	(seasonsBest[s]).push( {j : j2, played:0, won:0, pctwon:0})

            // seasonsBest[s][j1].played++
            // seasonsBest[s][j2].played++
            // if (pm==2)
            // 	seasonsBest[s][j1].won++
            // if (pm==0)
            // 	seasonsBest[s][j2].won++
        });

        seasons.forEach((s) => {
            Object.keys(seasonsBestPlayed[s]).forEach((p) => {
                if (!seasonsBestPctWon[s][p]) {
                    if (seasonsBestPlayed[s][p] != 0) {
                        let pct = seasonsBestWon[s][p] === undefined ? 0 : seasonsBestWon[s][p] / seasonsBestPlayed[s][p];

                        // if (isNaN(pct))
                        // 	console.log( seasonsBestWon[s][p] + " - " + seasonsBestPlayed[s][p] + " = " + pct)
                        seasonsBestPctWon[s][p] = pct;
                    }
                }
            });
        });
        seasons.forEach((s) => {
            seasonsBest[s] = [];
            Object.keys(seasonsBestPlayed[s]).forEach((p) => {
                seasonsBest[s].push([p, seasonsBestPlayed[s][p], seasonsBestWon[s][p], seasonsBestPctWon[s][p]]);
            });
        });
    }

    function TOPperformers(s, thresholdMatchs, topN) {
        const top50NofMatchs = seasonsBest[s]
            .filter((a) => {
                return a[1] >= thresholdMatchs;
            })
            .sort(function (a, b) {
                return b[1] - a[1];
            })
            .slice(0, topN - 1);
        // const top50NofWins =seasonsBest[s].sort(function(a, b){return b[2]-a[2]}).slice(0,49)
        const top50PctWins = seasonsBest[s]
            .filter((a) => {
                return a[1] >= thresholdMatchs;
            })
            .sort(function (a, b) {
                return b[3] - a[3];
            })
            .slice(0, topN - 1);
        // .slice(0,200)
        // console.log('#of matchs')
        // top50NofMatchs.forEach((p) => console.log(joueurs[p[0]] + " - " + p[1] + " - " + p[0]))
        // console.log('#of wins')
        // top50NofWins.forEach((p) => console.log(joueurs[p[0]] + " - " + p[2]))
        // console.log('% wins')
        // top50PctWins.forEach((p) => console.log(joueurs[p[0]] + " - " + p[3] + " - " + p[0]))
        // seasonsBest[2024].forEach((p) => {
        // if (!joueurs[p[0]])
        // 	alert(p[0] + " undefined")
        // console.log(joueurs[p[0]])})
    }

    function build_data_analysis() {
        analysis_src.forEach((a) => {
            let s = a[0];
            let md = a[1];
            let cat = a[2];
            let el = a[3];
            let m = a[4];
            let t = a[5];
            let v = el == "MG" ? parseFloat(a[6]) : parseInt(a[6]);

            if (!analysis[s]) analysis[s] = {};

            if (!analysis[s][md]) analysis[s][md] = {};

            if (!analysis[s][md][cat]) analysis[s][md][cat] = {};

            if (!analysis[s][md][cat][el]) analysis[s][md][cat][el] = {};

            if (!analysis[s][md][cat][el][m]) analysis[s][md][cat][el][m] = {};

            if (!analysis[s][md][cat][el][m][t]) analysis[s][md][cat][el][m][t] = 0;

            analysis[s][md][cat][el][m][t] = v;
        });
        // console.log(analysis)
    }

    function pickSeason(s) {
        // console.log('pickSeason')
        // searchDone=false

        // openGraph=false
        season = s.target.value;
        // console.log(matchs)
        analyseLicence();
    }

    function searchLic() {
        // console.log('searchLic')
        // console.log(matchs)

        searchDone = false;
        // openGraph=false
        joueur = "";
        if (licence == "") {
            msg = "Licence vide";
            return;
        }
        if (licence.length < 2) {
            msg = "Licence trop courte";
            return;
        }
        licN = parseInt(licence.substring(0, licence.length - 1));
        licL = licence.substring(licence.length - 1).toUpperCase();
        lic = licN + licL;

        if (joueurs[lic] == undefined) {
            msg = "Licence non présente";
            return;
        }

        joueur = joueurs[lic];
        nomJoueur = joueur;
        // console.log('searchLic before analyse')
        // console.log(matchs)
        analyseLicence();
        analyseLicenceAll();
    }

    function analyseLicence() {
        //Saison	Date	Catégorie	Mode de jeu	Licence 1	Pts 1	Reprises 1	Meilleure Série 1	Pts Match 1	Licence 2	Pts 2	Reprises 2
        // 0		1		2			3			4			5		6			7					8			9			10		11
        //Meilleure Série 2	Pts Match 2	Format	Niveau	Type	L_H
        //12				13			14		15		16		17

        // console.log('analyseLicence')
        matchsLic = [];
        classifsLic = {};
        modesClassif = [];

        // console.log(matchs)

        matchs.forEach((m) => {
            // console.log(m[2])

            if ((m[4] == lic && m[0] == season) || (m[9] == lic && m[0] == season)) {
                if (!(m[5] == 0 && m[10] == 0)) matchsLic.push(m);
            }
        });

        // Saison	Licence	Mode de jeu	Catégorie	Étoile	Moy 2.80	Moy 3.10	#Matchs
        // 0			1		2			3			4		5			6			7

        classifPrevSeason = season > classifs[classifs.length - 1][0];
        let chkSeason = classifPrevSeason ? season - 1 : season;

        // console.log('check saison')
        // console.log(season)
        // console.log(classifPrevSeason)

        classifs.forEach((c) => {
            if (c[0] == chkSeason && c[1] == lic) {
                if (!modesClassif[c[2]]) {
                    modesClassif.push(c[2]);
                    classifsLic[c[2]] = [];
                }
                let m2 = c[5];
                let m3 = c[6];
                if (c[2] == "3 Bandes") {
                    // m2=parseFloat(c[5]).toFixed(3)
                    // m3=parseFloat(c[6]).toFixed(3)
                } else {
                    // m2=parseFloat(c[5]).toFixed(2)
                    // m3=parseFloat(c[6]).toFixed(2)
                }
                if (c[3] == "Masters" || c[3] == "N1" || c[3] == "N2") c[9] = m3;
                else c[9] = m2;

                classifsLic[c[2]] = c;
            }
            canShowGraph = matchsLic.length > 0;
            // canShowGraph = !classifPrevSeason && matchsLic.length > 0;
        });

        modesClassif.sort(function (a, b) {
            return classifsLic[b][7] - classifsLic[a][7];
        });

        // console.log('matchslic')
        // console.log(matchsLic)
        buildMatchsSegmentation(matchsLic);
        if (matchsLic.length == 0) msg = "Aucun match";
        else if (matchsLic.length == 1) msg = "1 match";
        else msg = matchsLic.length + " matchs";
    }

    function analyseLicenceAll() {
        //Saison	Date	Catégorie	Mode de jeu	Licence 1	Pts 1	Reprises 1	Meilleure Série 1	Pts Match 1	Licence 2	Pts 2	Reprises 2
        // 0		1		2			3			4			5		6			7					8			9			10		11
        //Meilleure Série 2	Pts Match 2	Format	Niveau	Type	L_H
        //12				13			14		15		16		17

        // console.log('analyseLicence')
        matchsLicAll = [];

        // console.log(matchs)

        matchs.forEach((m) => {
            // console.log(m[2])

            if (m[4] == lic || m[9] == lic) {
                if (!(m[5] == 0 && m[10] == 0)) matchsLicAll.push(m);
            }
        });

        buildMatchsSegmentationAll(matchsLicAll);

        // console.log('analyse all')
        // console.log(matchsLicAll)
        // console.log(modesAll)
        // console.log(tableMatchRowsAll)
    }

    function buildMatchsSegmentation(lstmatchs) {
        // console.log('segment - matchs found')
        // console.log(lstmatchs)
        matchsByMode = {};
        bestSerieByMode = {};
        matchsByRes = { Gagnés: 0, Perdus: 0, Nuls: 0 };
        matchsByType = { Individuel: 0, "Par équipe": 0 };
        modes = [];
        adversaires = [];

        lstmatchs.forEach((m) => {
            let mode = m[3];
            let adv = "";
            let ms;

            if (m[4] == lic) {
                adv = m[9];
                if (m[8] == "2") matchsByRes["Gagnés"]++;
                if (m[8] == "0") matchsByRes["Perdus"]++;
                if (m[8] == "1") matchsByRes["Nuls"]++;
                ms = parseInt(m[7]);
            } else if (m[9] == lic) {
                adv = m[4];
                if (m[13] == "2") matchsByRes["Gagnés"]++;
                if (m[13] == "0") matchsByRes["Perdus"]++;
                if (m[13] == "1") matchsByRes["Nuls"]++;
                ms = parseInt(m[12]);
            }

            if (!modes.includes(mode)) modes.push(mode);
            if (!matchsByMode[mode]) {
                matchsByMode[mode] = [];
                bestSerieByMode[mode] = 0;
            }
            matchsByMode[mode].push(m);

            if (ms > bestSerieByMode[mode]) bestSerieByMode[mode] = ms;

            if (!adversaires.includes(adv)) adversaires.push(adv);

            if (m[16] == "I") matchsByType["Individuel"]++;
            else if (m[16] == "E") matchsByType["Par équipe"]++;
        });

        adversaires.sort(function (a, b) {
            if (joueurs[a] == undefined) return 0;
            if (joueurs[b] == undefined) return 0;

            return joueurs[a].localeCompare(joueurs[b]);
        });

        prepareTableMatch();
        // tableMatchRows.keys()
        searchDone = true;
    }

    function buildMatchsSegmentationAll(lstmatchs) {
        // console.log('segment - matchs found')

        matchsByModeAll = {};
        modesAll = [];

        lstmatchs.forEach((m) => {
            let mode = m[3];
            let adv = "";
            let ms;

            if (m[4] == lic) {
                adv = m[9];
                ms = parseInt(m[7]);
            } else if (m[9] == lic) {
                adv = m[4];
                ms = parseInt(m[12]);
            }

            if (!modesAll.includes(mode)) modesAll.push(mode);
            if (!matchsByModeAll[mode]) {
                matchsByModeAll[mode] = [];
            }
            matchsByModeAll[mode].push(m);
        });

        prepareTableMatchAll();
        // tableMatchRows.keys()
    }

    function searchByName() {
        let n = nomJoueur.toUpperCase();
        let ln = n.length;
        joueursSearch = [];
        joueursSrc.forEach((j) => {
            if (j[1].substring(0, ln) == n) joueursSearch.push(j);
        });
        // console.log(joueursSearch)
        // open=true
        showModal = true;
    }

    function showGraphique() {
        showGraphModal = true;
    }

    function showGraphiqueAllSeason() {
        showGraphAllSeasonModal = true;
    }

    function toggleView() {
        showAccordion = !showAccordion;
    }
</script>

<main>

    <div>
        <Modal size="xl" isOpen={openInfo} {toggleInfo}>
            <ModalHeader {toggleInfo}>Information</ModalHeader>
            <ModalBody>
                Sous le nom du joueur est affiché un résumé de la saison (# total de matchs, matchs gagnés, perdus et nuls, # d'adversaires,
                # matchs en individuel et par équipe). En dessous sont affichées les données de classification pour la saison choisie si
                celle-ci est terminée ou de la saison précédente si la saison choisie est en cours. Les modes de jeu pour lesquels la
                classification est plus ancienne sont affichés en italique.
                <br />
                <br />
                Plus bas on trouve des boutons pour chaque mode de jeu joué dans la saison (triés par nombre de matchs joués). En appuyant dessus
                on affiche ou on masque la liste des matchs correspondant.
                <br />
                On peut afficher les matchs d'un seul mode de jeu à la fois.
                <br /><br />
                Le bouton &nbsp<i class="bi bi-graph-down"></i> permet d'afficher le graphique des performances des matchs de la saison (ce
                bouton n'apparaît que si la saison choisie est terminée).
                <br />
                Dans le graphique on peut choisir d'afficher les performances dans les modes de jeu joués dans la saison. Sera alors affichée
                la courbe des performances du joueur (soit la moyenne soit la méilleure série dans les matchs).
                <br />
                En cliquant sur un point de la courbe on visualise les informations du match.
                <br /><br />
                En plus de la courbe du joueur on visualise 2 lignes horizontales qui représentent la valeur moyenne des perdants et celle des
                gagnants.
                <br />
                Si on change la catégorie les valeurs des courbes sont ajustées en fonction du format du billard de la catégorie choisie.
            </ModalBody>
            <ModalFooter>
                <Button color="primary" on:click={toggleInfo}>Fermer</Button>
            </ModalFooter>
        </Modal>
    </div>

    <div>
        <Modal size="xl" isOpen={openInfoTop} {toggleInfoTop}>
            <ModalHeader {toggleInfoTop}>Information</ModalHeader>
            <ModalBody>
                Le bouton [<strong>Toutes les saisons &nbsp</strong><i class="bi bi-graph-down"></i>&nbsp;] affiche le graphique des
                performances de tous les matchs de toutes les saisons disponibles.
                <br />
                Dans ce graphique on peut choisir le mode de jeu, le format du billard selon lequel calculer les valeurs et la valeur à afficher
                pour les matchs joués.
                <br />Il est possible d'afficher la moyenne réalisée dans le match (Moy), la moyenne réalisée en enlevant la meilleure série
                (Moy - MS) ou la meilleure série (MS)
                <br /> En cliquant sur un point de la courbe on visualise les informations du match.
                <br /><br /><strong
                    >N.B. Par défaut les courbes affichent les valeurs 3m10, cliquer sur 2m80 si le joueur n'appartient à une catégorie
                    billard match</strong
                >
                <br /><br />
                Le bouton <strong>Exporter</strong>
                permet de télécharger un fichier csv avec tous les matchs du joueur dans toutes les saisons disponibles.
                <br /><br />
                Les boutons en dessous permettent de choisir la saison.
            </ModalBody>
            <ModalFooter>
                <Button color="primary" on:click={toggleInfoTop}>Fermer</Button>
            </ModalFooter>
        </Modal>
    </div>

    <nav class="navbar sticky-top" style="background-color:#0D6EFD; padding:0px; height:70px ">
        <div class="container-fluid" style="align-items: left">
            <h2 class="navbar-brand" style="width:100%; text-align: left; color:white; font-size:1.6em">
                <img src="./logo_ffb.png" alt="" width="60" height="60" class="d-inline-block align-text-center" />
                Matchs de Carambole
            </h2>
        </div>
    </nav>

    {#await promise}
        <div style="display:flex; justify-content:center; align-items:center; min-height:100vh">
            <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    {:then data}
        <div class="center" style="padding:12px">
            <Row cols="(3)">
                <Col xs="auto">
                    <input style="font-size:1em;" placeholder="Licence" bind:value={licence} />
                </Col>
                <Col xs="auto">
                    <button disabled={licence.length < 3} on:click={() => searchLic()}>
                        <i class="bi bi-search"></i>&nbsp;&nbsp;
                    </button>
                </Col>
                <Col xs="auto">
                    <input style="font-size:1em;" placeholder="Nom joueur" bind:value={nomJoueur} />
                </Col>
                <Col xs="auto">
                    <button disabled={nomJoueur.length < 3} on:click={() => searchByName()}>
                        <i class="bi bi-search"></i>&nbsp;&nbsp;
                    </button>
                </Col>
                <Col xs="auto">
                    {#if lic_stack_nof > 0}
                        <Button color="primary" on:click={() => goBack()}>
                            <i class="bi bi-arrow-left"></i>
                        </Button>
                    {/if}
                </Col>
            </Row>
            <ModalCmpt on:joueurChosen={joueurChosen} bind:showModal joueurs={joueursSearch}></ModalCmpt>
        </div>

        <hr style="margin:0" />
        {#if searchDone}
            {#if showGraphModal}
                {#if !classifPrevSeason}
                <ModalGraph
                    bind:showGraphModal
                    modesclassif={modesClassif}
                    classifs={classifsLic}
                    matchs={tableMatchRows}
                    mdData={analysis[season]}
                    {season}
                    {joueurs}
                ></ModalGraph>
                {:else}
                <ModalGraphCurSeason
                    bind:showGraphModal
                    classifs={classifsLic}
                    matchs={tableMatchRows}
                    {season}
                    {joueurs}
                ></ModalGraphCurSeason>
                {/if}
            {/if}
            {#if showGraphAllSeasonModal}
                <ModalGraphAllSeasons bind:showGraphAllSeasonModal modes={modesAll} matchs={tableMatchRowsAll} {joueurs} classifs={classifsLic}
                ></ModalGraphAllSeasons>
            {/if}
            <div style="padding:12px">
                <Button color="primary" on:click={() => toggleInfoTop()}>
                    <i class="bi bi-info-square"></i>
                </Button>
                &nbsp;
                <Button color="primary" on:click={() => showGraphiqueAllSeason()}>
                    Toutes les saisons&nbsp;&nbsp<i class="bi bi-graph-down"></i>
                </Button>
                &nbsp;
                <ButtonGroup>
                    <Button color="primary" on:click={() => exportCSV()}>Exporter</Button>
                </ButtonGroup>
            </div>
            <div style="padding:12px">
                <ButtonGroup>
                    {#each seasons as s}
                        <Button color="primary" value={s} on:click={(e) => pickSeason(e)}>{s}</Button>
                    {/each}
                </ButtonGroup>
            </div>
            <div style="padding:12px">
                <div>
                    {#key [lic, season]}
                        <ResCard
                            clsPrevSeason={classifPrevSeason}
                            j={joueur}
                            {season}
                            msByMode={bestSerieByMode}
                            n={matchsLic.length}
                            classifs={classifsLic}
                            modesclassif={modesClassif}
                            {res}
                            resMatchs={matchsByRes}
                            adv={adversaires.length}
                            Ind={matchsByType["Individuel"]}
                            eq={matchsByType["Par équipe"]}
                        ></ResCard>
                    {/key}
                </div>
                <hr />
                <div class="row">
                    <div class="col-2">
                        <Button color="primary" on:click={() => toggleInfo()}>
                            <i class="bi bi-info-square"></i>
                        </Button>
                    </div>
                    <div class="col-8 col-lg-7 col-xl-6 col-xxl-5 center">
                        <span class="matchText">Matchs</span>
                    </div>
                    <div class="col-2 right">
                        {#if canShowGraph}
                            <Button color="primary" on:click={() => showGraphique()}>
                                <i class="bi bi-graph-down"></i>
                            </Button>
                        {/if}
                    </div>
                </div>
                {#key [lic, season]}
                    {#if showAccordion}
                        <MatchsTablesAccordion
                            modes={modesAll}
                            {tableMatchRows}
                            {tableMatchsHeaders}
                            {joueurs}
                            {season}
                            on:clickAdv={clickAdv}
                        ></MatchsTablesAccordion>
                    {:else}
                        <MatchsTables {tableMatchRows} {tableMatchsHeaders} {joueurs} {season} on:clickAdv={clickAdv}></MatchsTables>
                    {/if}
                {/key}
            </div>
            <div class="center">
                <Button color="primary" on:click={() => (searchDone = false)}>
                    <!-- <i  class="bi bi-journal-medical"></i> -->
                    Revenir à la page d'accueil
                </Button>
            </div>
        {:else}
            <div class="" style="padding:12px">
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col-10">
                        <Card style="border:0">
                            <CardText>
                                Taper le numéro de la licence (chiffres et lettre) dans le champ de gauche et cliquer sur le bouton <i
                                    class="bi bi-search"
                                ></i>
                                à sa droite.
                                <br />
                                A défaut on peut taper les premières lettres (au moins 3) du nom du joueur dans le champ de droite puis cliquer
                                sur le bouton
                                <i class="bi bi-search"></i>
                                correspondant.
                                <br />
                                Une liste de noms de joueurs apparaîtra parmi lesquels on pourra choisir le joueur qui nous intéresse.
                                <br /><br />
                                Ci-dessous on peut consulter différentes statistiques générales.
                            </CardText>
                        </Card>
                    </div>
                </div>
                <hr />
                <Statistiques stats={globalstats} {seasonsBest} {joueurs} {seasons} on:clickTop={clickTop}></Statistiques>
            </div>
        {/if}
    {/await}
</main>

<style>
    .matchText {
        padding-left: 4px;
        margin-left: 14px;
        font-weight: bold;
        font-size: 1.4em;
        text-align: center;
    }
    .center {
        text-align: center;
        display: flex;
        /* //flex-flow: column; */
        justify-content: center;
    }
    .right {
        text-align: end;
        display: flex;
        /* //flex-flow: column; */
        justify-content: end;
    }
</style>
